<template>
  <div id="app">
      <transition name="slide">
        <router-view></router-view>
      </transition>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style lang="scss">
@import "./assets/vendor/css/normalize.css";
@import "./assets/vendor/css/grid.css";
@import "./assets/resources/css/setup.min.css";

.slide-leave-active {
      transition: opacity 1s ease;
      opacity: 0;
      animation: slide-out 1s ease-out forwards;
  }

  .slide-leave {
      opacity: 1;
      transform: translateX(0);
  }

  .slide-enter-active {
      animation: slide-in 1s ease-out forwards;
  }

  @keyframes slide-out {
      0% {
          transform: translateY(0);
      }
      100% {
          transform: translateY(-30px);
      }
  }

  @keyframes slide-in {
      0% {
          transform: translateY(-30px);
      }
      100% {
          transform: translateY(0);
      }
  }
</style>



// WEBPACK FOOTER //
// App.vue?238ce47d